import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';

interface HomeProps {
  loggedIn: boolean;
  email: string;
  setLoggedIn: (loggedIn: boolean) => void;
}

const Home: React.FC<HomeProps> = ({ loggedIn, email, setLoggedIn }) => {
  const navigate = useNavigate();

  const onButtonClick = () => {
    if (loggedIn) {
      localStorage.removeItem('user');
      setLoggedIn(false);
    } else {
      navigate('/login');
    }
  };


  return (
    <div className="mainContainer">
      <div className={'titleContainer'}>
        <div>Welcome!</div>
      </div>
      <div></div>
      <div className={'buttonContainer'}>
  {!loggedIn && ( // Only show the button when not logged in
    <input
      className={'inputButton'}
      type="button"
      onClick={onButtonClick}
      value='Log in' // Show "Log in" text
    />
  )}

  {loggedIn && <div>Logged in as {email}</div>}
</div>
    </div>
  );
};

export default Home;
